/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Dispatch_ToastInputs */

const en_delivery_board_dispatch_toast = /** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order dispatched to rider!`)
};

const es_delivery_board_dispatch_toast = /** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Pedido despachado al repartidor!`)
};

const fr_delivery_board_dispatch_toast = /** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commande confiée au coursier !`)
};

const de_delivery_board_dispatch_toast = /** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung an Kurier übergeben!`)
};

const id_delivery_board_dispatch_toast = /** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesanan dikirim ke kurir!`)
};

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const ja_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const zh_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const ar_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const it_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const ru_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const pt_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/** @type {(inputs: Delivery_Board_Dispatch_ToastInputs) => LocalizedString} */
const ko_delivery_board_dispatch_toast = en_delivery_board_dispatch_toast;

/**
* | output |
* | --- |
* | "Order dispatched to rider!" |
*
* @param {Delivery_Board_Dispatch_ToastInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_dispatch_toast = /** @type {((inputs?: Delivery_Board_Dispatch_ToastInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Dispatch_ToastInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_dispatch_toast(inputs)
	if (locale === "es") return es_delivery_board_dispatch_toast(inputs)
	if (locale === "fr") return fr_delivery_board_dispatch_toast(inputs)
	if (locale === "de") return de_delivery_board_dispatch_toast(inputs)
	if (locale === "ja") return ja_delivery_board_dispatch_toast(inputs)
	if (locale === "zh") return zh_delivery_board_dispatch_toast(inputs)
	if (locale === "ar") return ar_delivery_board_dispatch_toast(inputs)
	if (locale === "id") return id_delivery_board_dispatch_toast(inputs)
	if (locale === "it") return it_delivery_board_dispatch_toast(inputs)
	if (locale === "ru") return ru_delivery_board_dispatch_toast(inputs)
	if (locale === "pt") return pt_delivery_board_dispatch_toast(inputs)
	return ko_delivery_board_dispatch_toast(inputs)
});